import { useState, useEffect, useRef, useCallback } from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import { useLanguage } from "../i18n/LanguageContext";

function AnimatedNumber({ value, suffix, isVisible }) {
  const [display, setDisplay] = useState(0);
  const num = parseInt(value, 10) || 0;
  const hasAnimated = useRef(false);

  useEffect(() => {
    if (!isVisible || hasAnimated.current) return;
    hasAnimated.current = true;
    const duration = 1800;
    const steps = 40;
    const increment = num / steps;
    let current = 0;
    let step = 0;

    const timer = setInterval(() => {
      step++;
      current = Math.min(Math.round(increment * step), num);
      setDisplay(current);
      if (step >= steps) clearInterval(timer);
    }, duration / steps);

    return () => clearInterval(timer);
  }, [isVisible, num]);

  return (
    <span>{isVisible ? display : 0}{suffix}</span>
  );
}

export default function Stats() {
  const [ref, isVisible] = useScrollReveal();
  const { t } = useLanguage();

  return (
    <section id="stats" data-testid="stats-section" ref={ref} className="bg-[#1E3455] border-y border-slate-700/40">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-0 md:divide-x md:divide-slate-800">
          {t.stats.map((stat, i) => (
            <div key={i} data-testid={`stat-${i}`}
              className="flex flex-col items-center md:items-start md:px-10 gap-1 transition-all duration-700"
              style={{ opacity: isVisible ? 1 : 0, transform: isVisible ? "translateY(0)" : "translateY(20px)", transitionDelay: `${i * 100}ms` }}>
              <div className="text-4xl md:text-5xl font-bold gold-gradient-text leading-none"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                <AnimatedNumber value={stat.value} suffix={stat.suffix} isVisible={isVisible} />
              </div>
              <div className="text-slate-300 text-[11px] uppercase tracking-widest mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
